import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const ProductTypesSelector = ({ productTypes = [], value = [], onChange }) => {
  const { t } = useTranslation()

  const handleChange = e => onChange(e.target.value)

  return (
    <div>
      <ComboBox
        menuItems={productTypes.map(p => ({ label: p.name, value: p.id }))}
        value={value}
        multiple
        fullWidth
        label={t('Tipo de producto')}
        handleChange={handleChange}
        placeholder={t('Todas')}
      />
    </div>
  )
}

export default ProductTypesSelector
